export default __webpack_public_path__ + "static/media/finance.b91d0832.svg";